import { render, staticRenderFns } from "./AgentSettlementManagement.vue?vue&type=template&id=5a0029e4&scoped=true"
import script from "./AgentSettlementManagement.vue?vue&type=script&lang=js"
export * from "./AgentSettlementManagement.vue?vue&type=script&lang=js"
import style0 from "./AgentSettlementManagement.vue?vue&type=style&index=0&id=5a0029e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0029e4",
  null
  
)

export default component.exports